<mat-card class="loren-map-details">
  <button
    mat-icon-button
    class="loren-map-details-close-button"
    id="close-map-sidebar"
    [title]="'infrastructure.close' | transloco"
    (click)="closed.emit()">
    <mat-icon>close</mat-icon>
  </button>
  <img
    class="loren-map-details-image"
    [src]="asset().avatar"
    [alt]="asset().name"
    [width]="200"
    [height]="200"/>
  <mat-card class="loren-map-details-status">
    <div class="loren-map-details-status-value">
      <mat-icon svgIcon="check"></mat-icon>
      <span class="loren-map-details-status__text">
        {{ "infrastructure.parameters_ok" | transloco }}
      </span>
    </div>

    <div class="loren-map-details-status-updated">
      <p class="loren-map-details-status-updated__title">
        {{ "infrastructure.last_updated" | transloco }}
      </p>
      <p class="loren-map-details-status-updated__value">
        {{ assetUpdated() | lorenDate }}
      </p>
    </div>
  </mat-card>

  <div>
    <h3 class="loren-map-details-title">
      {{ asset().name }}
    </h3>
    <p class="loren-map-details-info">
      <span class="loren-map-details-info__title"
        >{{ "infrastructure.groups" | transloco }}:
      </span>
      @let groups = groupsNames$ | async;
      @if (groups) {
        <span class="loren-map-details-info__value">{{ groups.join(", ") }}</span>
      }
    </p>
    <p class="loren-map-details-info">
      <span class="loren-map-details-info__title"
        >{{ "infrastructure.description" | transloco }}:
      </span>
      <span class="loren-map-details-info__value">{{
        asset().description
      }}</span>
    </p>
    <p class="loren-map-details-info">
      <span class="loren-map-details-info__title">{{ "infrastructure.location" | transloco }}:</span>
      <span class="loren-map-details-info__value">
        {{ location()?.lat }}, {{ location()?.lng }}
      </span>
    </p>
  </div>
  <div class="loren-map-details-actions">
    <div>
      @if (location()) {
        <a mat-stroked-button
          class="me-1"
          href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={{location().lat}},{{location().lng}}"
          target="_blank">
          <img [src]="'/assets/icons/google-street-view-icon.png'" width="18" alt="Google Street View"/>
        </a>
      }
      @if (location()) {
        <a
          mat-stroked-button
          class="me-1"
          href="https://www.google.com/maps?daddr={{location().lat}},{{location().lng}}"
          target="_blank">
          <mat-icon color="primary" class="m-0">directions</mat-icon>
        </a>
      }
    </div>
    <button matButton="filled" [id]="asset().id.toString()" (click)="navigateToAsset()">
      {{ "infrastructure.details" | transloco }}
    </button>
  </div>
</mat-card>
